<template>
  <SharedDocumentsPickerDialog
    v-model="localSelection"
    :is-open="isOpen"
    :allowed-types="allowedTypes"
    @update:isOpen="handleOpenUpdate"
    @confirm="onConfirm"
  />
</template>

<script>
import SharedDocumentsPickerDialog from '@/common/documents-picker/SharedDocumentsPickerDialog.vue'

export default {
  name: 'QuestionAnswerAddDocumentsDialog',
  components: {
    SharedDocumentsPickerDialog,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    modelValue: {
      type: Array,
      default: () => ([]),
    },
    allowedTypes: {
      type: Array,
      default: () => ['file'],
      validator: (val) => Array.isArray(val) && val.every(t => ['file', 'folder'].includes(t)),
    },
  },
  emits: ['update:isOpen', 'update:modelValue', 'confirm'],
  data () {
    return {
      localSelection: this.sanitizeSelection(this.modelValue),
    }
  },
  watch: {
    modelValue: {
      handler (value) {
        this.localSelection = this.sanitizeSelection(value)
      },
      deep: true,
    },
    allowedTypes: {
      handler () {
        this.localSelection = this.sanitizeSelection(this.localSelection)
      },
      deep: true,
    },
    isOpen (value) {
      if (value) {
        this.localSelection = this.sanitizeSelection(this.modelValue)
      }
    },
  },
  methods: {
    sanitizeSelection (value) {
      const allowed = new Set(this.allowedTypes)
      return (value || []).filter(item => item && allowed.has(item.type))
    },
    handleOpenUpdate (value) {
      if (!value) {
        this.localSelection = this.sanitizeSelection(this.modelValue)
      }
      this.$emit('update:isOpen', value)
    },
    onConfirm (selection) {
      const sanitized = this.sanitizeSelection(selection || this.localSelection)
      this.localSelection = sanitized
      this.$emit('update:modelValue', sanitized)
      this.$emit('confirm', sanitized)
    },
  },
}
</script>
